<modal
  class="OverviewModal"
  [config]="{
    type: 'flyout',
    size: 'medium',
    direction: 'bottom',
    header: {
      title: 'Overview',
      showClose: showCloseIcon(),
      showBack: showBackIcon(),
    },
  }"
  [condition]="isMobileOverviewOpen"
  (cancel)="handleCancel()"
>
  @if (!showCloseIcon()) {
    <zip-button
      headerRightContent
      class="ClaimDetail__overview-modal--close"
      [config]="{
        level: 'text',
        content: 'Done',
        size: 'fit',
      }"
      (zipButtonClicked)="handleCancel()"
    >
    </zip-button>
  }

  <section body class="ClaimDetail__overview--mobile">
    <div class="ClaimDetail__overview-card--mobile">
      <card>
        <span title class="OverviewModal__Header">Overview</span>
        <span body>
          @if (mobileConfig?.overview) {
            <mp-overview
              class="OverviewModal__Section"
              [attributeListContext]="context"
              [attributeList]="mobileConfig.overview.attributeList.attributes"
              [useCustom]="!!overviewCustomContent"
              >{{ overviewCustomContent }}
            </mp-overview>
          }
          <hr class="OverviewModal__Separator" />
          @if (mobileConfig?.downloads) {
            <side-panel-downloads
              class="SidePanel__Section"
              [attributeListContext]="context"
              [downloadsLabel]="mobileConfig?.downloads.label"
              [attributeList]="mobileConfig?.downloads.attributeList.attributes"
              [useCustom]="!!mobileConfig?.downloads?.customContent"
              >{{
                mobileConfig?.downloads?.customContent
              }}</side-panel-downloads
            >
          }
          <hr class="OverviewModal__Separator" />
          @if (mobileConfig?.resources) {
            <mp-resources
              class="OverviewModal__Section"
              [attributeListContext]="context"
              [resourcesLabel]="mobileConfig.resources.label"
              [attributeList]="mobileConfig.resources.attributeList.attributes"
              [useCustom]="!!resourcesCustomContent"
              >{{ resourcesCustomContent }}</mp-resources
            >
          }
        </span>
      </card>
    </div>
  </section>
</modal>
